import { BestPerformingExposure } from '../../../../../../models/influencer';
import { platformIconPathById } from '../../../../../app.constants';
import { DateUtils } from '../../../../../utils/date.utils';
import { Router } from '@angular/router';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { BestPerformingExposureComponent } from '../best-performing-exposure.component';
import { UserService } from '../../../../../services/user.service';
var BestPerformingExposureItemComponent = /** @class */ (function () {
    function BestPerformingExposureItemComponent(pdfService, userService, router) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.router = router;
        this.bestPerformingExposure = new BestPerformingExposure();
    }
    BestPerformingExposureItemComponent.prototype.getPlatformIcon = function (platformId) {
        if (!platformId) {
            return '';
        }
        return platformIconPathById[platformId].path;
    };
    BestPerformingExposureItemComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded(BestPerformingExposureComponent.COMPONENT_NAME);
    };
    BestPerformingExposureItemComponent.prototype.onLoadedImageError = function () {
        console.log('Loaded image fail');
        this.pdfService.updateNumberImageLoaded(BestPerformingExposureComponent.COMPONENT_NAME);
    };
    Object.defineProperty(BestPerformingExposureItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingExposureItemComponent.prototype.formatPublishData = function (publishDate) {
        return DateUtils.formatDate(publishDate);
    };
    BestPerformingExposureItemComponent.prototype.openPostPage = function () {
        var currentInfluencer = this.userService.getInfluencerInfo();
        // influencer platform version
        if (currentInfluencer) {
            return this.router.navigate(['dashboard', 'post', this.bestPerformingExposure.urlHash]);
        }
        else {
            return this.router.navigate(['post'], { queryParams: {
                    influencerId: this.bestPerformingExposure.influencer_id,
                    urlHash: this.bestPerformingExposure.urlHash,
                    fullUrl: this.bestPerformingExposure.url,
                    relativePath: this.bestPerformingExposure.relativepath,
                    activeAccount: this.activeAccount
                } });
        }
    };
    return BestPerformingExposureItemComponent;
}());
export { BestPerformingExposureItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure-item/best-performing-exposure-item.component.ts.pre-build-optimizer.js